<template>
  <v-card color="grey lighten-3">
    <v-card-text class="pt-5 pb-4 px-5">
      <v-text-field
        v-if="!hideFixPrice"
        solo
        v-model.number="form.promotion_fix_price"
        :rules="[(v) => !!v || 'Price is required']"
        label="Fix product price (THB)"
        :disabled="isEditPromotion"
      ></v-text-field>
      <div
        style="
          border: 1px solid grey;
          border-radius: 20px;
          padding: 20px;
          background-color: white;
        "
        v-if="
          !hidePackage &&
          (form.promotion_order_type == 1 || form.promotion_order_type == 3)
        "
      >
        <h3>Store package</h3>
        <v-radio-group
          row
          v-model="form.isAllPackage"
          @change="
            form.isAllPackageStore = true;
            form.promotion_package = [];
            form.promotion_package_store = [];
            storeList = [];
          "
        >
          <v-radio color="primary" label="All Packages" :value="true"></v-radio>
          <v-radio
            color="primary"
            label="Select Packages"
            :value="false"
          ></v-radio>
        </v-radio-group>

        <div v-if="form.isAllPackage == false">
          <v-select
            :loading="isLoadingPackage"
            multiple
            label="Package"
            v-model="form.promotion_package"
            :items="package_list"
            item-value="package_id"
            item-text="package_name"
            clearable
            @input="
              form.promotion_package_store = [];
              getStoreByPackage();
            "
            :rules="[(v) => v.length > 0 || 'Package is required']"
          ></v-select>
          <div style="display: flex; align-items: center">
            <div>
              <v-radio-group
                row
                v-model="form.isAllPackageStore"
                @change="form.promotion_package_store = []"
              >
                <v-radio
                  color="primary"
                  label="All Stores"
                  :value="true"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="Select Stores"
                  :value="false"
                ></v-radio>
              </v-radio-group>
            </div>

            <v-dialog
              v-model="dialog"
              width="800"
              v-if="form.isAllPackageStore == false"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :color="
                    form.promotion_package_store.length > 0 ? 'info' : 'error'
                  "
                  v-on="on"
                  flat
                  outline
                  >View Store List</v-btn
                >
              </template>

              <v-card>
                <v-card-title primary-title>
                  <h2>Select stores</h2>
                </v-card-title>

                <v-card-text style="max-height: 60vh; overflow: auto">
                  <v-text-field
                    label="Search store name"
                    prepend-icon="search"
                    v-model="searchStoreName"
                  ></v-text-field>
                  <v-card
                    flat
                    style="border: 1px solid #333; border-radius: 10px"
                  >
                    <v-data-table
                      v-model="selectedStoreList"
                      :headers="headers"
                      :items="filteredStoreList"
                      :pagination.sync="pagination"
                      select-all
                      item-key="store_id"
                      class="elevation-0"
                      :loading="isLoadingStore"
                    >
                      <template v-slot:items="props">
                        <tr
                          :active="props.selected"
                          @click="props.selected = !props.selected"
                        >
                          <td>
                            <v-checkbox
                              :input-value="props.selected"
                              primary
                              hide-details
                            ></v-checkbox>
                          </td>
                          <td>{{ props.item.store_name_th }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" flat @click="dialog = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    color="success"
                    class="elevation-0"
                    @click="confirmSelectedStoreList()"
                  >
                    Confirm
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  props: {
    form: {
      default() {
        return {};
      },
    },
    hidePackage: {
      default() {
        return false;
      },
    },
    hideFixPrice: {
      default() {
        return false;
      },
    },
    province: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedStoreList: [],
      dialog: false,
      pagination: {
        sortBy: "name",
      },
      selected: [],
      headers: [
        {
          text: "Store name",
          align: "center",
          value: "name",
          sortable: false,
        },
      ],
      desserts: [
        {
          name: "Frozen Yogurt",
        },
        {
          name: "Ice cream sandwich",
        },
        {
          name: "Eclair",
        },
        {
          name: "Cupcake",
        },
        {
          name: "Gingerbread",
        },
        {
          name: "Jelly bean",
        },
        {
          name: "Lollipop",
        },
        {
          name: "Honeycomb",
        },
        {
          name: "Donut",
        },
        {
          name: "KitKat",
        },
      ],
      isLoadingPackage: false,
      isLoadingStore: false,
      storeList: [],
      searchStoreName: "",
    };
  },
  async created() {
    this.initData();
    await this.getStoreByPackage();
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        let result = this.storeList.filter((val) =>
          this.form.promotion_package_store.includes(val.store_id)
        );

        this.selectedStoreList = JSON.parse(JSON.stringify(result));
        console.log(this.selectedStoreList);
      }
    },
  },
  computed: {
    ...mapGetters({
      isEditPromotion: "isEditPromotion",
    }),
    ...mapState({
      package_list: (state) => state.fetchPackageBack.package_list,
    }),
    filteredStoreList() {
      return this.storeList.filter((val) =>
        val.store_name_th
          .toLowerCase()
          .includes(this.searchStoreName.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions({
      fetchStoreByPackage: "fetchStoreBack/fetchStoreByPackage",
    }),

    async initData() {
      this.isLoadingPackage = true;
      await this.$store.dispatch("fetchPackageBack/getPackageList", {
        province_name: this.province || this.$route.params.province,
      }),
        (this.isLoadingPackage = false);
    },
    confirmSelectedStoreList() {
      this.form.promotion_package_store = this.selectedStoreList.map(
        (val) => val.store_id
      );
      this.dialog = false;
    },
    async getStoreByPackage() {
      this.storeList = [];
      this.isLoadingStore = true;
      let payload = {
        province: this.province || this.$route.params.province,
        packages: this.form.promotion_package,
      };
      this.storeList = await this.fetchStoreByPackage(payload);
      this.isLoadingStore = false;
    },
  },
};
</script>

<style></style>
